import { useQuery } from '@tanstack/react-query'

import { ApplicationAuthModel } from '@/common/models/application'
import { api } from '@/lib/axios'

async function getApplicationAuth(applicationId: string) {
  const response = await api.backend.get('/application-auth/findOne', {
    params: {
      relations: {
        where: {
          applicationId,
        },
      },
    },
  })
  return response.data
}

export function useGetApplicationAuth(applicationId: string) {
  const { data, isLoading, error } = useQuery<ApplicationAuthModel | null>({
    queryKey: ['/application-auth/findOne', applicationId],
    queryFn: () => getApplicationAuth(applicationId),
    enabled: !!applicationId,
  })

  return { data, isLoading, error }
}
